import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactNode } from "react";
import classes from "./CustomAccordion.module.scss";

// eslint-disable-next-line complexity
const CustomAccordion = ({
  title,
  badge = false,
  badgeIcon = null,
  badgeCount = 0,
  children,
  size = "sm",
  defaultExpanded = false,
  disabled = false,
  tooltip,
}: {
  title: string;
  badge?: boolean;
  badgeIcon?: ReactNode;
  badgeCount?: number;
  children: ReactNode;
  size?: "sm" | "md" | "lg";
  defaultExpanded?: boolean;
  disabled?: boolean;
  tooltip?: string;
}) => {
  const summary = (
    <AccordionSummary
      className={`${classes["custom-accordion-header"]} ${
        classes[`header-${size}`]
      }`}
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel-content"
      id="panel-header"
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
      sx={disabled ? { cursor: "default" } : undefined}
    >
      {title}
      {badge && (
        <Typography component="div" className={classes["filterBadge"]}>
          {badgeIcon ? badgeIcon : badgeCount}
        </Typography>
      )}
    </AccordionSummary>
  );

  const accordion = (
    <Accordion
      className={classes["custom-accordion-container"]}
      defaultExpanded={disabled ? false : defaultExpanded}
      expanded={disabled ? false : undefined}
      onChange={disabled ? () => {} : undefined}
    >
      {summary}
      <AccordionDetails className={classes["custom-accordion-content"]}>
        {children}
      </AccordionDetails>
    </Accordion>
  );

  return tooltip ? (
    <Tooltip title={tooltip} arrow>
      <span style={{ display: "block" }}>{accordion}</span>
    </Tooltip>
  ) : (
    accordion
  );
};

export default CustomAccordion;
